import MapFeature from './MapFeature'

/**
 * @typedef {'top-right'|'top-left'|'bottom-right'|'bottom-left'} MapFeaturePosition
 * Where to place this control on the map
 */

/**
 * Base class for map controls.
 */
export default class MapFeatureControl extends MapFeature {

    /** @type {MapFeaturePosition} */
    position = 'bottom-left'

    /** @type {import('@bikemap/js/utils/dom').TooltipPosition} */
    tooltipPosition = 'right'

    /**
     * Sets position of this feature on the map.
     * @param {MapFeaturePosition} position
     */
    setPosition(position) {
        this.position = position
        this.tooltipPosition = position.includes('right') ? 'left' : 'right'
    }

}
